<script>
    import { MessageStore } from '../stores/MessageStore.svelte.js';
    import { CircleX as CloseIcon } from 'lucide-svelte';
</script>

<aside class="absolute top-4 right-4 z-9500 w-96">
    {#each MessageStore.list as msg (msg.id)}
        <article
            class="mb-2 block w-full cursor-default rounded-sm
                        border-1 px-2 py-1 text-right text-sm font-bold
                        shadow-sm"
            class:bg-info-100={msg.type === 'info'}
            class:border-info-500={msg.type === 'info'}
            class:text-info-800={msg.type === 'info'}
            class:bg-success-100={msg.type === 'success'}
            class:border-success-500={msg.type === 'success'}
            class:text-success-800={msg.type === 'success'}
            class:bg-warning-100={msg.type === 'warning'}
            class:border-warning-500={msg.type === 'warning'}
            class:text-warning-800={msg.type === 'warning'}
            class:bg-error-100={msg.type === 'error'}
            class:border-error-500={msg.type === 'error'}
            class:text-error-800={msg.type === 'error'}>
            <div class="items-top flex gap-2">
                <button class="cursor-pointer" onclick={() => MessageStore.remove(msg.id)}>
                    <CloseIcon size="16" class="shrink-0 pt-1" />
                </button>
                {msg.text}
            </div>
        </article>
    {/each}
</aside>
